declare global {
  interface Window {
    railsAppCookieDomain?: string
  }
}

export function setPermanentCookie(name: string, value: string, domain?: string) {
  const dom =
    domain ||
    window.railsAppCookieDomain ||
    document.body.dataset.cDomain ||
    window.location.hostname

  const expirationDate = new Date()
  expirationDate.setFullYear(expirationDate.getFullYear() + 20)
  const cookieString = `${name}=${value}; path=/; domain=${dom}; expires=${expirationDate.toUTCString()}`
  document.cookie = cookieString
}
